export default __webpack_public_path__ + "static/media/jolt-100-5.8a469416.jpg";